import { render, staticRenderFns } from "./AuthorCourseComment.vue?vue&type=template&id=fa184f3c&scoped=true&"
import script from "./AuthorCourseComment.vue?vue&type=script&lang=js&"
export * from "./AuthorCourseComment.vue?vue&type=script&lang=js&"
import style0 from "./AuthorCourseComment.vue?vue&type=style&index=0&id=fa184f3c&lang=scss&scoped=true&"
import style1 from "./AuthorCourseComment.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa184f3c",
  null
  
)

export default component.exports